export const filter = {
    id: "",
    name: "",
    city_id: "",
    code: "",
    search: "",
    created_at: "",
    updated_at: "",
};
